import FJConfig from '../FJConfig';

export const STYLE_LIST = [
    {
        categoryName: 'anime',
        list: [
            {
                name: 'green-art',
                value: 'green-art',
                img: 'green-art.png',
                buryName: 'Green Art',
            },
            {
                name: 'purple-american-comic',
                value: 'purple-american-comic',
                img: 'purple-american-comic.png',
                buryName: 'Purple Comic',
            },
            {
                name: 'vintage-2d-illustration',
                value: 'vintage-2d-illustration',
                img: 'vintage-2d-illustration.png',
                buryName: 'Vintage 2D',
            },
            {
                name: 'claymation',
                value: 'claymation',
                img: 'claymation.png',
                buryName: 'Claymation',
            },
            {
                name: 'felt',
                value: 'felt',
                img: 'felt.png',
                buryName: 'Felt',
            },
            {
                name: '2d-vector-art',
                value: '2d-vector-art',
                img: '2d-vector-art.png',
                buryName: '2D Vector',
            },
            {
                name: 'vector-illustration',
                value: 'vector-illustration',
                img: 'vector-illustration.png',
                buryName: 'Vector',
            },
            {
                name: 'retro-anime',
                value: 'retro-anime',
                img: 'retro-anime.png',
                buryName: 'Retro Anime',
            },
            {
                name: 'enchanted-comic-fantasy',
                value: 'enchanted-comic-fantasy',
                img: 'enchanted-comic-fantasy.png',
                buryName: 'Comic Fantasy',
            },
            {
                name: 'ghibli',
                value: 'ghibli',
                img: 'ghibli.png',
                buryName: 'Ghibli',
            },
            {
                name: 'cute-vector',
                value: 'cute-vector',
                img: 'cute-vector.png',
                buryName: 'Cute Vector',
                isNew: true,
            },
        ],
    },
    {
        categoryName: 'painting',
        list: [
            {
                name: 'watercolor-1',
                value: 'watercolor-1',
                img: 'watercolor-1.png',
                buryName: 'Watercolor 1',
            },
            {
                name: 'red-toned-oil-painting',
                value: 'red-toned-oil-painting',
                img: 'red-toned-oil-painting.png',
                buryName: 'Oil Painting 1',
            },
            {
                name: 'color-sketch',
                value: 'color-sketch',
                img: 'color-sketch.png',
                buryName: 'Color Sketch',
            },
            {
                name: 'brown-watercolor',
                value: 'brown-watercolor',
                img: 'brown-watercolor.png',
                buryName: 'Watercolor 2',
            },
            {
                name: 'artsy',
                value: 'artsy',
                img: 'artsy.png',
                buryName: 'Artsy',
            },
            {
                name: 'pink-hand-drawn-art',
                value: 'pink-hand-drawn-art',
                img: 'pink-hand-drawn-art.png',
                buryName: 'Pink Sketch',
            },
            {
                name: 'vibrant-fluid-portrait',
                value: 'vibrant-fluid-portrait',
                img: 'vibrant-fluid-portrait.png',
                buryName: 'Fluid Portrait',
            },
            {
                name: 'picture-book-1',
                value: "children's-picture-book",
                img: 'children-s-picture-book.png',
                buryName: 'Picture Book 1',
            },
            {
                name: 'picture-book-2',
                value: 'picture-book-2',
                img: 'picture-book-2.png',
                buryName: 'Picture Book 2',
                isNew: true,
            },
            {
                name: 'monochrome-sketch',
                value: 'monochrome-sketch',
                img: 'monochrome-sketch.png',
                buryName: 'Mono Sketch',
            },
            {
                name: 'pencil-sketch',
                value: 'pencil-sketch',
                img: 'pencil-sketch.png',
                buryName: 'Pencil Sketch',
            },
            {
                name: 'oil-painting',
                value: 'oil-painting',
                img: 'oil-painting.png',
                buryName: 'Oil Painting 2',
            },
            {
                name: 'manga-art',
                value: 'manga-art',
                img: 'manga-art.png',
                buryName: 'Manga Art',
            },
        ],
    },
    {
        categoryName: '3d',
        list: [
            {
                name: 'fantasy-cgi',
                value: 'fantasy-cgi',
                img: 'fantasy-cgi.png',
                buryName: 'Fantasy CGI',
            },
            {
                name: '3d-pink-and-blue',
                value: '3d-pink-and-blue',
                img: '3d-pink-and-blue.png',
                buryName: 'Dreamy 3D',
            },
            {
                name: 'tranquil-3d',
                value: 'tranquil-3d',
                img: 'tranquil-3d.png',
                buryName: '3D Cartoon',
            },
            {
                name: 'blue-3d',
                value: 'blue-3d',
                img: 'pastel-3d.png',
                buryName: 'Pastel 3D',
            },
            {
                name: 'orange',
                value: 'orange',
                img: 'orange.png',
                buryName: 'Orange',
                isNew: true,
            },
        ],
    },
    {
        categoryName: 'stylize',
        list: [
            {
                name: 'verdant-realism',
                value: 'verdant-realism',
                img: 'verdant-realism.png',
                buryName: 'Realism',
            },

            {
                name: 'purple-glowing-illustration',
                value: 'purple-glowing-illustration',
                img: 'purple-glowing-illustration.png',
                buryName: 'Glow Art',
            },
            {
                name: 'purple-art',
                value: 'purple-art',
                img: 'purple-art.png',
                buryName: 'Purple Art',
            },
            {
                name: 'cyberpunk',
                value: 'cyberpunk',
                img: 'cyberpunk.png',
                buryName: 'Cyberpunk',
            },
            {
                name: 'metallic',
                value: 'metallic',
                img: 'metallic.png',
                buryName: 'Metallic',
            },
            {
                name: 'horror-comics',
                value: 'horror-comics',
                img: 'horror-comics.png',
                buryName: 'Horror Comics',
            },
            {
                name: 'golden-hour',
                value: 'golden-hour',
                img: 'golden-hour.png',
                buryName: 'Golden Hour',
            },
            {
                name: 'dark-cyan',
                value: 'dark-cyan',
                img: 'dark-cyan.png',
                buryName: 'Dark Cyan',
                isNew: true,
            },
            {
                name: 'pop-art',
                value: 'pop-art',
                img: 'pop-art.png',
                buryName: 'Pop Art',
                isNew: true,
            },
        ],
    },
    {
        categoryName: 'holiday',
        list: [
            {
                name: 'christmas-1',
                value: 'christmas-1',
                img: 'christmas-1.png',
                buryName: 'Christmas 1',
            },
            {
                name: 'christmas-2',
                value: 'christmas-2',
                img: 'christmas-2.png',
                buryName: 'Christmas 2',
            },
            {
                name: 'christmas-3',
                value: 'christmas-3',
                img: 'christmas-3.png',
                buryName: 'Christmas 3',
            },
            {
                name: 'christmas-4',
                value: 'christmas-4',
                img: 'christmas-4.png',
                buryName: 'Christmas 4',
            },
            {
                name: 'halloween',
                value: 'halloween',
                img: 'halloween.png',
                buryName: 'Halloween',
            },
        ],
    },
];
export const MAX_GENERATE_NUM = 4;
export const MOBILE_PREVIEW_DATA = [
    {
        type: 'video',
        url: FJConfig.imgPath + 'mobileImgToImg/' + 'dog.mp4?v=' + FJConfig.version,
        title: '图片1',
    },
    {
        type: 'video',
        url: FJConfig.imgPath + 'mobileImgToImg/' + 'people.mp4?v=' + FJConfig.version,
        title: '视频1',
    },
    {
        type: 'video',
        url: FJConfig.imgPath + 'mobileImgToImg/' + 'architecture.mp4?v=' + FJConfig.version,
        title: '图片2',
    },
];
